var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDownFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H6.625V14.3871H4V4Z",
    fill: "#CF2F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.0828C20 9.46798 19.6384 8.93536 19.1145 8.68112C19.2538 8.44872 19.3341 8.17782 19.3341 7.88858C19.3341 7.22239 18.9094 6.6526 18.3136 6.42925C18.4325 6.21012 18.5001 5.95986 18.5001 5.69439C18.5001 4.83392 17.792 4.13394 16.9215 4.13394H9.76501L7.5625 4.95519V13.5025H8.43567L11.3804 16.8699L11.6334 18.248C11.7135 18.6837 12.0967 19 12.5448 19H13.0864C14.1293 19 14.9778 18.1613 14.9778 17.1304C14.9778 16.4824 14.8517 15.8501 14.6029 15.2507L14.0409 13.8374H17.9478C18.8182 13.8374 19.5265 13.1374 19.5265 12.277C19.5265 11.9547 19.427 11.6548 19.257 11.4059C19.7028 11.1298 20 10.64 20 10.0828Z",
    fill: "#CF2F92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownFilled);
export default __webpack_public_path__ + "static/media/thumbsDownFilled.6a4eb42693ac4c111a51a0e473768391.svg";
export { ForwardRef as ReactComponent };